// src/store/slices/restaurantsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../config/api";
import { Pagination } from "react-bootstrap";

export const fetchMainMeals = createAsyncThunk(
  "restaurants/fetchMainMeals",
  async (_, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/admin/categories`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchTrainerMainMeals = createAsyncThunk(
  "restaurants/fetchTrainerMainMeals",
  async (id, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/trainee/categories/active?resturant_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchTrainersMainMeals = createAsyncThunk(
  "restaurants/fetchTrainersMainMeals",
  async (_, thunkAPI) => {
    console.log("00000");

    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/trainee/categories/active`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
      console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchMainMeal = createAsyncThunk(
  "restaurants/fetchMainMeal",
  async (data, thunkAPI) => {

    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/admin/categories/${data.MainMealID}`,

        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
      console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addMainMeals = createAsyncThunk(
  "restaurants/addMainMeals",
  async (mainMealData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${API_URL}/restaurant/admin/categories`, mainMealData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
                    "Content-Type": "multipart/form-data",

        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateMainMeal = createAsyncThunk(
  "restaurants/updateMainMeal",
  async ({ id, data }, thunkAPI) => {

    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(
        `${API_URL}/restaurant/admin/categories/${id}`
        ,  data, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
          "Content-Type": "multipart/form-data",

        },
      });

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
); export const deleteMainMeal = createAsyncThunk(
  "restaurants/deleteMainMeal",
  async (mainMealID, thunkAPI) => {

    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.delete(`${API_URL}/restaurant/admin/categories/${mainMealID}`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const activeMainMeal = createAsyncThunk(
  "restaurants/activeMainMeal",
  async ({ page = 1 }, thunkAPI) => {
    console.log(page, "mainMealData");

    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.get(`${API_URL}/restaurant/trainee/categories/active`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const restaurantsSlice = createSlice({
  name: "restaurants",
  initialState: {
    list: [],
    singleRestaurant: null,
    Pagination: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMainMeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMainMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.categories;
        state.Pagination = action.payload;
      })
      .addCase(fetchMainMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTrainersMainMeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainersMainMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.categories;
        state.Pagination = action.payload;
      })
      .addCase(fetchTrainersMainMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })      .addCase(fetchTrainerMainMeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerMainMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.categories;
        state.Pagination = action.payload;
      })
      .addCase(fetchTrainerMainMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })






      .addCase(activeMainMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(activeMainMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.Pagination = action.payload;
      })
      .addCase(activeMainMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })



      .addCase(fetchMainMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMainMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.singleRestaurant = action.payload;
      })
      .addCase(fetchMainMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(addMainMeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMainMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(addMainMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(updateMainMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMainMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(updateMainMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(deleteMainMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMainMeal.fulfilled, (state, action) => {
        state.loading = false;
        // state.list.push(action.payload);
      })
      .addCase(deleteMainMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default restaurantsSlice.reducer;
